import { useRef } from "react";
import styles from "./index.module.css";
import ProjectItem from "./ProjectItem";

const ProjectsList = ({ projects, selected, setSelected }) => {
  const containerEl = useRef();

  return (
    <div
      ref={containerEl}
      className={styles.containerSectionWarrper}
      id="smooth-content"
    >
      <ul
        className={styles.projectsList}
      >
        {projects.map((project, i) => {
          return (
            <li  key={"projet-" + i}>
              {selected == i ? (
                <ProjectItem
                  projet={project}
                  selected
                  index={i + 1}
                />
              ) : (
                <ProjectItem
                  onHover={(e) => {
                    /*  e.stopPropagation();
                      e.preventDefault(); */
                    setSelected(i);
                  }}
                  projet={project}
                  index={i + 1}
                />
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ProjectsList;
